// src/config/runtime.ts
export const R = {
  CLOUD_NAME: import.meta.env.VITE_CLOUDINARY_CLOUD_NAME,              // e.g. yldsocialvideos
  FUNCTIONS_BASE: import.meta.env.VITE_FUNCTIONS_BASE ?? '/functions', // if you call any edge funcs
};

// Fail fast in dev so we don't ship a broken build
export function assertRuntime() {
  if (!R.CLOUD_NAME) {
    throw new Error('[config] Missing VITE_CLOUDINARY_CLOUD_NAME');
  }
}
